import { OperatorProductComponent } from './pages/catalog/product/operator/operator-product.component';
import { Routes } from '@angular/router';
import { ShopListComponent } from './pages/shop/shop-list/shop-list.component';
import { AuthGuardService } from './services/guard/auth-guard.service';
import { ExportFileComponent } from './pages/import/export-file/export-file.component';
import { ProductListComponent } from './pages/catalog/product-list/operator/product-list.component';
import { SellerProductListComponent } from './pages/catalog/product-list/seller/seller-product-list.component';
import { SellerProductComponent } from './pages/catalog/product/seller/seller-product.component';
import { TaxonomyDetailsComponent } from './pages/settings/taxonomy/taxonomy-details/taxonomy-details.component';
import { CatalogImportComponent } from './pages/import/catalog-import/catalog-import/catalog-import.component';
import { ImportWorkflowComponent } from './pages/import/catalog-import/import-workflow/import-workflow.component';
import { UsersComponent } from './pages/settings/users/users.component';
import { MainHelpComponent } from './pages/help/pages/main-help/main-help.component';
import { ShopDetailComponent } from './pages/shop/shop-detail/shop-detail.component';
import { DocApiComponent } from './pages/docs/doc-api/doc-api.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { ProfileTmpComponent } from './pages/profile-tmp/profile-tmp.component';
import { NotificationsComponent } from './pages/settings/notifications/notifications.component';

export const routes: Routes = [
  {
    path: 'profile',
    component: ProfileTmpComponent
  },
  {
    path: 'login',
    component: DashboardComponent
  },
  {
    path: 'seller/shop',
    component: ShopDetailComponent,
    canActivate: [AuthGuardService],
    data: { requiredRole: ['ROLE_SELLER', 'ROLE_SELLER_ADMIN'] },
  },
  {
    path: 'seller/catalog',
    children: [
      {
        path: '',
        component: SellerProductListComponent,
        canActivate: [AuthGuardService],
        data: { requiredRole: ['ROLE_SELLER', 'ROLE_SELLER_ADMIN'] },
      },
      {
        path: ':id',
        component: SellerProductComponent,
        canActivate: [AuthGuardService],
        data: { requiredRole: ['ROLE_SELLER', 'ROLE_SELLER_ADMIN'] },
      },
    ],
  },
  {
    path: 'operator/shop',
    children: [
      {
        path: '',
        component: ShopListComponent,
        canActivate: [AuthGuardService],
        data: { requiredRole: ['ROLE_OPERATOR', 'ROLE_OPERATOR_ADMIN', 'ROLE_SUPER_ADMIN'] },
      },
      {
        path: ':id',
        component: ShopDetailComponent,
      },
    ],
  },
  {
    path: 'operator/catalog',
    children: [
      {
        path: '',
        component: ProductListComponent,
        canActivate: [AuthGuardService],
        data: { requiredRole: ['ROLE_OPERATOR', 'ROLE_OPERATOR_ADMIN', 'ROLE_SUPER_ADMIN'] },
      },
      {
        path: ':id',
        component: OperatorProductComponent,
        canActivate: [AuthGuardService],
        data: { requiredRole: ['ROLE_OPERATOR', 'ROLE_OPERATOR_ADMIN', 'ROLE_SUPER_ADMIN'] },
      },
    ],
  },
  {
    path: 'import',
    children: [
      {
        path: 'export',
        component: ExportFileComponent,
        canActivate: [AuthGuardService],
        data: { requiredRole: ['ROLE_SELLER', 'ROLE_SELLER_ADMIN', 'ROLE_SUPER_ADMIN'  , 'ROLE_OPERATOR_SELLER'  ] },
      },
      {
        path: 'catalog-import',
        component: CatalogImportComponent,
        canActivate: [AuthGuardService],
        data: { requiredRole: ['ROLE_SELLER', 'ROLE_SELLER_ADMIN', 'ROLE_SUPER_ADMIN'  , 'ROLE_OPERATOR_SELLER'  ] },
      },
      {
        path: 'progress/:id',
        component: ImportWorkflowComponent,
        canActivate: [AuthGuardService],
        data: { requiredRole: ['ROLE_SELLER', 'ROLE_SELLER_ADMIN', 'ROLE_SUPER_ADMIN'  , 'ROLE_OPERATOR_SELLER'  ] },
      },
    ],
  },
  {
    path: 'settings',
    children: [
      {
        path: 'taxonomy',
        component: TaxonomyDetailsComponent,
      },
      {
        path: 'users',
        component: UsersComponent,
        canActivate: [AuthGuardService],
        data: { requiredRole: ['ROLE_OPERATOR_ADMIN', 'ROLE_SELLER_ADMIN', 'ROLE_SUPER_ADMIN', 'ROLE_OPERATOR'] },
      },
      {
        path: 'notifications',
        component: NotificationsComponent,
        canActivate: [AuthGuardService],
        data: { requiredRole: [ 'ROLE_SUPER_ADMIN', 'ROLE_PRIVILEGED_ADMIN'] },
      },
    ],
  },
  { path: 'help', component: MainHelpComponent},
  {
    path: 'docapi',
    loadComponent: () => import('./pages/docs/doc-api/doc-api.component').then(m => m.DocApiComponent) 
  },
  { path: '**', redirectTo: 'login' },
];
